import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MentionCount' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%'
    },
    icon: {
        width: 16,
        height: 16
    },
    title: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        flex: 1
    },
    count: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px'
    }
});
